import { Link } from 'react-router-dom';
import { articles } from '@/mocks/comics';

export default function LatestComics() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              最新漫画
            </h2>
            <p className="text-sm text-foreground-600">每周更新，精彩不断</p>
          </div>
          <Link
            to="/category/breastfeeding-daily"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium no-underline flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 no-underline"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 奶水漫画`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex flex-wrap gap-2 mb-2">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}